<p-dataView #dv [value]="videoUrlsWithLoadMore" [paginator]="false" [rows]="12" filterBy="name"
    layout="grid" [ngClass]="{ 'center-items': isCol4 }">
    
    <ng-template let-video pTemplate="gridItem">
        <ng-container *ngIf="!video.isLoadMoreButton; else loadMoreButtonTemplate">
            <div class="ss-l-video-container-widget item cursor-pointer" (click)="openModal(video)">
                <img [src]="video.thumbnail" />
            </div>
        </ng-container>
    </ng-template>
</p-dataView>

<!-- Template separado para o botão -->
<ng-template #loadMoreButtonTemplate>
    <div class="flex align-items-center justify-content-center item" style="height: 100%;">
        <button pButton pRipple label="Carregar Mais" [loading]="isLoadingSlides" (click)="loadMore()"
            class="ml-2 mr-2"></button>
    </div>
</ng-template>
